import React from "react";
export const PatientSvg = () => (
  <svg 
  id="Capa_1" 
  enableBackground="new 0 0 510.213 510.213" 
  fill="currentColor"
  viewBox="0 0 510.213 510.213">
    <g><path d="m315.213.377c-107.523 0-195 87.477-195 195 0 48.182 17.575 92.331 46.638 126.395l-24.348 24.348-21.213-21.213-121.29 121.29 63.64 63.64 121.29-121.29-21.213-21.213 24.285-24.285c34.173 29.479 78.646 47.329 127.212 47.329 107.523 0 195-87.477 195-195s-87.477-195.001-195.001-195.001zm-251.573 467.033-21.213-21.213 78.863-78.863 21.213 21.213zm251.573-107.033c-90.981 0-165-74.019-165-165 0-90.982 74.019-165 165-165s165 74.019 165 165-74.018 165-165 165z"/><path d="m360.213 90.377h-90v75h-60v105h210v-135h-60zm-90 150h-30v-45h30zm60 0h-30v-75-45h30v15zm60-75v75h-30v-75z"/></g></svg>
);
